import { useMutation } from "@apollo/client";

import { MapEditorObservationPanel_ObservationEcologicalFunctionDeleteDocument } from "./mutations.generated";
import { MapEditorObservationPanelObservationEditableDocument } from "./queries.generated";

export function useUnlinkObservationFromEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationEcologicalFunctionDeleteDocument, {
        refetchQueries: [MapEditorObservationPanelObservationEditableDocument],
    });

    const unlinkEcologicalFunction = (observationId: string, ecologicalFunctionId: string) =>
        mutate({
            variables: {
                input: {
                    observationId,
                    ecologicalFunctionId,
                },
            },
        });

    return [unlinkEcologicalFunction, result] as const;
}
